import { http } from "../client";
import axios from "axios";
export var DeleteUserTrackFailureVariant;
(function (DeleteUserTrackFailureVariant) {
    DeleteUserTrackFailureVariant[DeleteUserTrackFailureVariant["NotFound"] = 0] = "NotFound";
    DeleteUserTrackFailureVariant[DeleteUserTrackFailureVariant["Forbidden"] = 1] = "Forbidden";
})(DeleteUserTrackFailureVariant || (DeleteUserTrackFailureVariant = {}));
var mapErrorToFailureVariant = function (error) {
    var _a;
    if (axios.isAxiosError(error)) {
        var status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
        if (status === 404) {
            return DeleteUserTrackFailureVariant.NotFound;
        }
        if (status === 403) {
            return DeleteUserTrackFailureVariant.Forbidden;
        }
    }
    return null;
};
export var deleteUserTrack = function (id) {
    return http.api
        .delete("tracks/" + id)
        .then(function (response) { return ({ id: response.data.track_id }); })
        .catch(function (error) { return Promise.reject(mapErrorToFailureVariant(error)); });
};
